'use strict';

function K2Application(services) {
  this.services = services;
  this.userSetting = null;

  this.init();
}

K2Application.prototype = $.extend({}, {
  constructor: 'K2Application',

  //**************************************************************************

  t: function t(string) {
    var _this = this;

    return _this.services.get('translator').trans(string);
  },

  path: function path(path, params) {
    var _this = this;

    return _this.services.get('router').path(path, params);
  },

  formation: function formation(action) {
    var _this = this;

    return _this.services.get('router').bridgeFormation(action);
  },

  get: function () {
    var _this = this;

    var action = arguments[0];
    var data = null;
    var callback = null;

    if (arguments.length === 2) {
      callback = arguments[1];
    } else if (arguments.length === 3) {
      data = arguments[1];
      callback = arguments[2];
    }

    action = _this.path(action, data);

    $.get(action, callback);

    return _this;
  },

  post: function () {
    var _this = this;

    var action = arguments[0];
    var params = null;
    var data = null;
    var callback = null;

    if (arguments.length === 2) {
      callback = arguments[1];
    } else if (arguments.length === 3) {
      data = arguments[1];
      callback = arguments[2];
    } else if (arguments.length === 4) {
      params = arguments[1];
      data = arguments[2];
      callback = arguments[3];
    }

    action = _this.path(action, params);

    $.post(action, data, callback);

    return _this;
  },

  getFormation: function () {
    var _this = this;

    var action = _this.formation(arguments[0]);
    var data = null;
    var callback = null;

    if (arguments.length === 2) {
      callback = arguments[1];
    } else if (arguments.length === 3) {
      data = arguments[1];
      callback = arguments[2];
    }

    $.get(action, data, callback);

    return _this;
  },

  postFormation: function () {
    var _this = this;

    var action = _this.formation(arguments[0]);
    var data = null;
    var callback = null;

    if (arguments.length === 2) {
      callback = arguments[1];
    } else if (arguments.length === 3) {
      data = arguments[1];
      callback = arguments[2];
    }

    $.post(action, data, callback);

    return _this;
  },

  param: function param(param) {
    var _this = this;

    return _this.services.get('configurations').param(param);
  },

  setParam: function setParam(param, value) {
    var _this = this;

    _this.services.get('configurations').setParam(param, value);

    return _this;
  },

  viewPrintMessage: function viewPrintMessage() {
    var _this = this;

    _this.services.get('notifications').viewPrintMessage();

    return _this;
  },

  viewSuccessMessage: function viewSuccessMessage() {
    var _this = this;

    _this.playSuccessSound();

    return _this.services.get('notifications').viewSaveMessage();
  },

  viewErrorMessage: function viewErrorMessage(data, callback) {
    var _this = this;

    _this.playErrorSound();

    return _this.services.get('notifications').viewErrorMessage(data, callback);
  },

  viewWarningMessage: function viewWarningMessage() {
    var _this = this;

    _this.playWarningSound();

    return _this.services.get('notifications').viewWarningMessage();
  },

  playSuccessSound: function playSuccessSound() {
    var _this = this;

    return _this.services.get('notifications').playSuccessSound();
  },

  playWarningSound: function playWarningSound() {
    var _this = this;

    return _this.services.get('notifications').playWarningSound();
  },

  playErrorSound: function playErrorSound() {
    var _this = this;

    return _this.services.get('notifications').playErrorSound();
  },

  getRouter: function getRouter() {
    var _this = this;

    return _this.services.get('router');
  },

  getService: function (service) {
    var _this = this;

    return _this.services.get(service);
  },

  setUserSetting: function setUserSetting(setting) {
    var _this = this;

    _this.setParam('user_setting', setting);
  },

  getUserSetting: function getUserSetting() {
    var _this = this;

    return _this.param('user_setting');
  },

  //**************************************************************************

  init: function init() {
    var _this = this;

    return _this;
  }
});
